/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors } from '@zapier/design-system';
import useGlobalIncidents from './useGlobalIncidents';
import Incidents from '../Incidents';
const containerCss = css `
  border: 1px solid ${Colors.warning};
  border-radius: 10px;
  overflow: hidden;
`;
/** Fetches and displays global incidents if any, or nothing. */
const GlobalIncidents = () => {
    const { data } = useGlobalIncidents();
    if (!data) {
        return null;
    }
    const title = data.length > 1
        ? 'Zapier has a couple of issues that may affect your Zaps'
        : 'Zapier has an issue that may affect your Zaps';
    return (isolateComponent("div", { css: containerCss },
        isolateComponent(Incidents, { incidents: data, title: title })));
};
/** @component */
export default GlobalIncidents;
